import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type ToastState = {
  isVisible: Boolean;
};

export enum ToastAlertType {
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}

export type ToastContent = {
  alertType: ToastAlertType;
  header: string;
  duration?: number;
  content?: string;
  action?: {
    label: string;
    href: string;
  };
};

const initialState: ToastState & ToastContent = {
  duration: undefined,
  isVisible: false,
  alertType: ToastAlertType.SUCCESS,
  header: '',
  content: '',
};

const ToastSlice = createSlice({
  name: 'toast',
  initialState,
  reducers: {
    hideToast: (state) => {
      state.isVisible = false;
      state.duration = undefined;
      state.alertType = ToastAlertType.SUCCESS;
      state.header = '';
      state.content = '';
      state.action = undefined;
    },
    showToast: (
      state,
      {
        payload: { alertType, header, duration, content = '', action },
      }: PayloadAction<ToastContent>,
    ) => {
      state.isVisible = true;
      state.duration = duration;
      state.alertType = alertType;
      state.header = header;
      state.content = content;
      state.action = action;
    },
  },
});

const { reducer, actions } = ToastSlice;

export const { hideToast, showToast } = actions;

export default reducer;
